{
  "home-page-title": "Webapp",
  "clear-btn": "クリア",
  "close-btn": "閉じる",
  "cancel-btn": "キャンセル",
  "delete-btn": "削除",
  "share-btn": "共有",
  "download-btn": "ダウンロード",
  "favorite-btn": "お気に入り",
  "ok-btn": "確認",
  "done-btn": "完了",
  "yes-btn": "はい",
  "no-btn": "いいえ",
  "create-story-btn": "ストーリーを作成",
  "submit-registration-btn": "アルバムを開く",
  "save-btn": "保存",
  "apply-btn": "適用",
  "checkout-btn": "会計へ",
  "info-title": "お知らせ",
  "registration-page-title": "登録",
  "contact-completion-page-title": "連絡先の入力",
  "registration-name-placeholder": "お名前",
  "registration-email-placeholder": "メールアドレス",
  "registration-email-or-phone-placeholder": "メールアドレスまたは米国の電話番号",
  "registration-country-code-default": "米国 +1",
  "registration-accept-label": "同意する",
  "registration-privacy-link": "利用規約",
  "registration-sms-agreement-label": "上記の電話番号宛てに Storibox から通知メッセージを受け取ることに同意します。画像に関する更新情報やリンクを含む SMS を受信することを理解しています。通信料・メッセージ料金が発生する場合があります。停止するには STOP と返信してください。",
  "registration-submit-loading-label": "読み込み中...",
  "registration-create-attendee-error-message": "利用者の作成に失敗しました。しばらくしてから再度お試しください。",
  "registration-create-attendee-email-confirmation-error-message": "利用者の作成に失敗しました。しばらくしてから再度お試しください。メールアドレスが確認済みかご確認ください。",
  "registration-invalid-us-phone-message": "+11234567890 のような米国の電話番号のみをご利用ください。",
  "registration-us-phone-length-message": "電話番号は国番号（+1）の後に10桁必要です。現在は {{length}} 桁です。",
  "registration-contact-required-message": "メールアドレスまたは電話番号は必須です。",
  "registration-invalid-email-message": "有効なメールアドレスを入力してください。",
  "registration-email-required-message": "メールアドレスは必須です。",
  "registration-sms-consent-required-message": "サービス登録には SMS 同意が必要です。",
  "registration-privacy-consent-required-message": "サービス登録には利用規約への同意が必要です。",
  "selfies-empty-title": "自撮り写真がありません！",
  "selfies-empty-message": "すばやく写真を見つけるために、\nグループ全員の\n鮮明なポートレート写真を\n追加してください。",
  "selfies-add-btn": "+ 追加",
  "selfie-upload-window-expired-message": "このイベントで自撮り写真を使って画像を検索できる時間が終了しました。",
  "purchase-btn": "購入",
  "home-select-all-btn": "すべて選択",
  "home-selected-count-label_one": "1件選択中",
  "home-selected-count-label_other": "{{count}}件選択中",
  "home-empty-album-message": "アルバムは空です",
  "home-empty-album-subtext-message": "まだアルバムに<br>画像がありません。",
  "home-qr-modal-title": "マイアルバムコード",
  "home-qr-modal-message": "このQRをキオスクでスキャンして写真にアクセスするか、ローミングフォトグラファーから求められた際に提示してください。",
  "home-qr-scanner-message": "フォト閲覧キオスク上のあなたの写真や動画に表示された QR コードをスキャンして、このアプリにメディアを連携します。",
  "home-qr-camera-access-message": "🎥 QRコードをスキャンするために、カメラアクセスが有効になっていることを確認してください。",
  "home-qr-scanner-show-my-qr-btn": "自分のQRを表示",
  "menu-registered-selfies": "登録済みの顔",
  "menu-qr-scanner": "QRスキャナー",
  "menu-album-code": "マイアルバムコード",
  "menu-privacy": "利用規約",
  "menu-faq": "FAQ",
  "menu-support": "サポート",
  "home-step-label": "ステップ {{amount}} / {{total}}",
  "home-select-up-to-images-title_one": "最大1枚選択",
  "home-select-up-to-images-title_other": "最大{{count}}枚選択",
  "home-select-as-many-images-title": "好きなだけ画像を選択",
  "home-select-target-label": "「{{name}}」用",
  "home-no-albums-found-message": "アルバムが見つかりません。",
  "home-event-config-missing-message": "このイベントは Webアプリ用に設定されていません。",
  "home-create-story-waiting-message": "ストーリーを作成しています。数分後にアルバムを再度ご確認ください。",
  "home-ugc-tooltip-message": "カメラロールから写真をアップロードして、キオスクで印刷できます！",
  "home-face-reco-tooltip-message": "グループ全員の自撮りまたは鮮明なポートレートをアップロードしてください。写真を見つけやすくなります！",
  "home-select-to-share-or-download-message": "共有またはダウンロードするには、少なくとも1枚の画像を選択してください。",
  "home-select-without-watermark-message": "共有またはダウンロードできるのは、透かしのない画像のみです。",
  "home-select-to-delete-message": "削除するには、少なくとも1枚の画像を選択してください。",
  "home-share-download-locked-message": "選択した写真の一部はロックされています。共有またはダウンロードするには、デジタルパスをご購入ください。",
  "home-face-register-help-message": "顔全体が均一に明るく、はっきり見えるようにしてください。表情は自然な状態でお願いします。",
  "home-no-selfies-suggestion-message": "自撮りがまだ登録されていないようです。今すぐ自撮りを登録して、大切な思い出を受け取りましょう。",
  "home-no-face-mask-message": "マスク不可",
  "home-selfie-maybe-later-btn": "後で",
  "home-delete-stock-warning-message": "削除対象にイベントのストック画像が含まれています。この画像はアルバムから削除できないため、スキップされます。",
  "home-delete-confirm-message": "アルバムから画像を削除すると元に戻せません。本当に続行しますか？",
  "home-delete-reason-not-wanted": "この画像はアルバムに不要です",
  "home-delete-reason-not-mine": "この画像は自分のものではありません",
  "home-delete-confirm-btn": "はい、削除",
  "home-upload-unsupported-format-message": "対応していない画像形式です。別の画像ファイルを使用してください。",
  "home-upload-generic-error-message": "写真のアップロード中にエラーが発生しました。再度お試しいただくか、サポートへご連絡ください。",
  "home-upload-limit-reached-message": "写真のアップロード上限に達しました。さらにアップロードが必要な場合はサポートへご連絡ください。",
  "home-upload-processing-error-message": "写真の処理中にエラーが発生しました。再度お試しいただくか、サポートへご連絡ください。",
  "home-upload-processing-message": "写真は1分ほどでアルバムに表示されます！",
  "home-upload-photo-message": "カメラロールから写真をアップロードして印刷しましょう！",
  "home-turn-me-into-tag-upload-message": "自撮りを撮影するか、カメラロールからポートレートをアップロードしてください。",
  "home-turn-me-into-tag-processing-message": "画像を変換しています！1分ほどしてからこのページを更新してください。",
  "home-download-waiting-message": "ファイルをダウンロード中です。<br/>しばらくお待ちください。",
  "download-selection-too-large-message": "選択数が多すぎるため、一度にダウンロードできません。写真数を減らすか、1枚ずつダウンロードしてください。",
  "home-download-360-message": "これはインタラクティブコンテンツです。アルバム内での閲覧を推奨します。必要に応じて生ファイルをダウンロードし、オンライン共有や360球面形式対応アプリで後から閲覧することもできます。",
  "home-scanned-image-confirm-message": "素敵な写真ですね！セキュリティのため確認してください。これはあなたの画像ですか？",
  "home-media-share-title": "メディア",
  "webapp-share-title": "私のStoriboxアルバムをチェックしてください！",
  "webapp-ogp-title": "私のStoriboxアルバム",
  "webapp-ogp-description": "私のStoriboxアルバムの写真と動画を閲覧・共有できます。",
  "home-share-files-unsupported-message": "このブラウザはファイル共有に対応していません。別のブラウザを使うか、直接ファイルをダウンロードしてください。",
  "home-share-files-waiting-message": "共有用ファイルをダウンロード中です。<br/>しばらくお待ちください。",
  "title-select-a-combo": "コンボを選択",
  "title-select-a-la-carte": "アラカルト",
  "title-shopping-cart": "ショッピングカート",
  "checkout-change-image-btn": "写真を変更",
  "checkout-empty-cart-message": "カートは空です",
  "checkout-add-product-btn": "商品を追加",
  "checkout-subtotal-label": "小計:",
  "checkout-taxes-label": "税金 (0%)",
  "checkout-total-label": "合計金額:",
  "checkout-promo-code-placeholder": "プロモーションコード",
  "checkout-add-on-btn": "+ 追加オプション",
  "checkout-invalid-promo-code-message": "無効、または適用できないプロモーションコードです！",
  "checkout-discount-label": "割引: {{title}}",
  "checkout-delete-restriction-message": "追加オプションを購入する場合、ショッピングカートには少なくとも1つのパッケージを残す必要があります。パッケージを変更する場合は、先に追加オプションをすべて削除してください。",
  "checkout-digital-package-upsell-message": "デジタルパッケージを<br>ショッピングカートに追加して、<br>すべてのデジタルコンテンツに<br>アクセスしますか？",
  "checkout-tip-message": "チップを追加しますか？",
  "checkout-tip-description": "チップはチームのサポートになります。",
  "checkout-no-tip-btn": "チップなし",
  "photo-plus-maybe-later-btn": "後で",
  "photo-plus-upgrade-btn": "はい、アップグレードする",
  "checkout-digital-package-duplicate-message": "ショッピングカートにはすでにデジタルアクセスパッケージがあります。<br>現在のパッケージを削除または購入するまで、新しいパッケージは追加できません。",
  "title-change-image": "写真を選択",
  "title-select-images": "写真を選択",
  "title-registered-selfies": "登録済みの顔",
  "title-privacy": "利用規約",
  "title-faq": "よくある質問",
  "title-shoot": "撮影",
  "title-remote-shoot": "リモート撮影",
  "title-thank-you": "ありがとうございます",
  "thank-you-header": "ご購入ありがとうございます！",
  "thank-you-message": "「アルバムに戻る」ボタンをクリックして、新しい写真をご覧ください。",
  "thank-you-go-to-album-btn": "アルバムに戻る",
  "order-pickup": "プリントステーションで写真をお受け取りください。",
  "shoot-again-btn": "もう一度撮影",
  "select-image-done-btn-name_final": "完了",
  "select-image-done-btn-name_incomplete": "次へ",
  "select-image-done-btn-counter_finite": "({{amount}}/{{total}})",
  "select-image-done-btn-counter_infinite": "({{amount}})",
  "remote-shoot-btn": "撮影",
  "remote-shoot-start-message": "カメラを見て、準備ができたら「撮影」を押してください",
  "remote-shoot-countdown-message": "ライトを見てください",
  "remote-shoot-rendering-message": "コンテンツを作成しています。数秒後にアルバムを確認して、新しい素敵な動画をご覧ください！"
}
